import React from 'react';
import { Form, Select } from 'antd';

const { Option } = Select;

interface IProps {
    onChangeFilter: (value: string, none_value: string, filter_name: string) => void
    value: string | null;
}

const FilterIssues = ({ onChangeFilter, value }: IProps) => {
    return (
        <Form.Item label='issues:'>
            <Select
                onChange={(value: string) => onChangeFilter(value, 'any', 'issues')}
                defaultValue='any'
                placeholder='please select'
                value={value}
            >
                <Option value='any'>- None -</Option>
                <Option value='resolved'>Resolved</Option>
                <Option value='opened'>Opened</Option>
                <Option value='all'>All issues</Option>
            </Select>
        </Form.Item>
    )
}

export default FilterIssues